import React, { useContext } from "react";

import { languages } from "../../languages/languages";
import UserContext from "../../languages/UserContext";

import ProjectCard from "./projectCard/ProjectCard";

import * as Images from "../../assets/Images.js";

import "./ProjectBlock.scss";

const ProjectBlock = () => {
  const user = useContext(UserContext);

  return (
    <section className="project" id="project">
      <h3 className="tab-title proj">{languages[user.lang].OurWorks}</h3>
      <div className="carousel">
        <ProjectCard
          images={[
            Images.ZelenkiOne,
            Images.ZelenkiTwo,
            Images.ZelenkiThree,
            Images.ZelenkiFour,
          ]}
          projectName={languages[user.lang].Project1}
          projectTags={languages[user.lang].Project1Tags}
        >
          {languages[user.lang].Project1Text}
        </ProjectCard>
        <ProjectCard
          images={[Images.Agh1, Images.Agh2, Images.Agh3, Images.Agh4]}
          projectName={languages[user.lang].Project5}
          projectTags={languages[user.lang].Project5Tags}
        >
          {languages[user.lang].Project5Text}
        </ProjectCard>
        <ProjectCard
          images={[
            Images.SzlakOne,
            Images.SzlakTwo,
            Images.SzlakThree,
            Images.SzlakFour,
          ]}
          projectName={languages[user.lang].Project2}
          projectTags={languages[user.lang].Project2Tags}
        >
          {languages[user.lang].Project2Text}
        </ProjectCard>
        <ProjectCard
          images={[
            Images.MiericOne,
            Images.MiericTwo,
            Images.MiericThree,
            Images.MiericFour,
          ]}
          projectName={languages[user.lang].Project3}
          projectTags={languages[user.lang].Project3Tags}
        >
          {languages[user.lang].Project3Text}
        </ProjectCard>
        <ProjectCard
          images={[
            Images.NiepolomOne,
            Images.NiepolomTwo,
            Images.NiepolomThree,
            Images.NiepolomFour,
            Images.NiepolomFive,
          ]}
          projectName={languages[user.lang].Project4}
          projectTags={languages[user.lang].Project4Tags}
        >
          {languages[user.lang].Project4Text}
        </ProjectCard>
      </div>
    </section>
  );
};

export default ProjectBlock;
